export function encode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(`0x${p1}`)));
}

export function decode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`;
    }).join(''));
}
